import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-92f6f596"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "text-base" }
const _hoisted_2 = { class: "mt-3" }
const _hoisted_3 = { class: "footer-setting" }
const _hoisted_4 = ["disabled"]

import { ref, computed, PropType } from 'vue'
import ReportProblemForm from '@/components/room/ReportProblemForm.vue'
import useSocketEvent from '@/composables/room/useSocketEvent'
import { ROOM_SPACE_URL } from '@/composables/api'
import useSpaceApi from '@/composables/api/useSpaceApi'
import useAuth from '@/composables/api/useAuth'
import { Engine } from '@/types/enums/room.enum'
import { useI18n } from 'vue-i18n'
import { EngineChangeSocketEmit } from '@/types/interfaces/room.interface'
import { engineAfter } from '@/composables/room/useRoomState'
import useGChatLog from '@/composables/api/useGChatLog'
import { detectSpaceRoomVersion } from '@/helpers/layout.helper'

interface ChangeVideoEnginePopupEmits {
  (e: 'update:modelValue', value: boolean): void
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ChangeVideoEnginePopup',
  props: {
  modelValue: {
    type: Boolean,
    default: false,
  },
  moveTo: {
    type: String as PropType<'main' | 'secondary' | 'whereby'>,
    default: 'secondary',
  },
},
  emits: ["update:modelValue"],
  setup(__props, { emit: __emit }) {

const props = __props
const { t } = useI18n()
const emit = __emit
const { getAccessInfo } = useAuth()
const { toggleEngine, switchToWhereBy } = useSpaceApi()
const { socket } = useSocketEvent()
const { sendSOSForChangeRoom } = useGChatLog()
const other = ref('')
const checkedIssues = ref<string[]>([])
const moveToTheRoom = computed(() =>
  props.moveTo === 'whereby'
    ? t('move-whereby-room', 'en')
    : props.moveTo === 'main'
    ? t('move-main-room', 'en')
    : t('move-secondary-room', 'en'),
)

const contentText = computed(() =>
  props.moveTo === 'whereby'
    ? t('room-changed.session-end-change-room.whereby-room')
    : props.moveTo === 'main'
    ? t('room-changed.session-end-change-room.main-room')
    : t('room-changed.session-end-change-room.second-room'),
)

const reportProblemPayload = computed(() => [
  ...checkedIssues.value,
  ...(other.value.trim() !== '' ? [`[99] ${other.value.trim()}`] : []),
])
const disabled = computed(() => (reportProblemPayload.value.length === 0 ? true : false))

const switchEngine = async () => {
  try {
    const { queryToken } = getAccessInfo()
    await sendSOSForChangeRoom(reportProblemPayload.value.join())
    let status: number
    let changedEngine: Engine
    if (props.moveTo === 'whereby') {
      const response = await switchToWhereBy(reportProblemPayload.value)
      status = response.status
      changedEngine = Engine.WHEREBY
    } else {
      const response = await toggleEngine(reportProblemPayload.value)
      status = response.status
      changedEngine = response.data.currentEngine
    }
    if (status === 200) {
      const spaceVersion = detectSpaceRoomVersion(changedEngine)
      const dataEmit: EngineChangeSocketEmit = {
        currentEngine: changedEngine,
        version: spaceVersion,
      }
      engineAfter.value = changedEngine
      socket.emit('engineChanged', dataEmit)
      if (spaceVersion === 'space5') {
        window.location.href = `${ROOM_SPACE_URL}/join?token=${queryToken}&tiger`
      } else {
        window.location.reload()
      }
    }
  } catch (err) {
    console.log(err)
    alert('Cannot toggle engine')
  }
}
const submit = async () => {
  emit('update:modelValue', false)
  await switchEngine()
  checkedIssues.value = []
}
const close = () => {
  emit('update:modelValue', false)
  checkedIssues.value = []
}

return (_ctx: any,_cache: any) => {
  const _component_Popup = _resolveComponent("Popup")!

  return (_openBlock(), _createBlock(_component_Popup, {
    title: moveToTheRoom.value,
    open: __props.modelValue,
    width: "500",
    onClose: close
  }, {
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("button", {
          disabled: disabled.value,
          type: "button",
          class: "btn btn-primary",
          onClick: submit
        }, " Submit ", 8, _hoisted_4),
        _createElementVNode("button", {
          type: "button",
          class: "btn btn-tertiary",
          onClick: close
        }, "Cancel")
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("p", null, _toDisplayString(contentText.value), 1),
        _createElementVNode("p", _hoisted_2, _toDisplayString(_unref(t)('room-changed.change-video-engine-content')), 1),
        _createVNode(ReportProblemForm, {
          modelValue: checkedIssues.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((checkedIssues).value = $event)),
          other: other.value,
          "onUpdate:other": _cache[1] || (_cache[1] = ($event: any) => ((other).value = $event))
        }, null, 8, ["modelValue", "other"])
      ])
    ]),
    _: 1
  }, 8, ["title", "open"]))
}
}

})